/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../.kubb/ToZod.ts";
import type { SerieVideoViewModel } from "../types/SerieVideoViewModel.ts";

export const serieVideoViewModelSchema = z.object({
  id: z.optional(z.number().int().describe("ID do vídeo.")),
  serieId: z.optional(z.number().int().describe("ID da série do vídeo.")),
  date: z.optional(z.string().datetime().describe("Data do vídeo.")),
  thumbnail: z
    .string()
    .describe("Caminho da imagem de capa no storage. Opcional.")
    .nullish(),
  active: z.optional(z.boolean().describe("Indica se o vídeo está ativo.")),
  title: z.string().describe("Título do vídeo no idioma corrente.").nullish(),
  resumee: z
    .string()
    .describe("Resumo do vídeo no idioma corrente. Opcional.")
    .nullish(),
  embed: z
    .string()
    .describe("HTML/embed do vídeo no idioma corrente.")
    .nullish(),
}) as unknown as ToZod<SerieVideoViewModel>;
